'use client'

import { ShareIcon } from '@/components/svg/share-icon/share-icon'
import s from './share-button.module.scss'
import {
  WhatsappShareButton,
  PinterestShareButton,
  EmailShareButton,
} from 'next-share'
import cx from 'classnames'
import { useRef, useState } from 'react'
import { VisibleOn } from '@/components/v3/atoms/visible-on'
import { useOnClickOutside } from 'usehooks-ts'
import { WhatsAppIcon } from '@/components/svg/whatsapp-icon/whatsapp-icon'
import { EmailIcon } from '@/components/svg/email-icon/email-icon'
import { PinterestIcon } from '@/components/svg/pinterest-icon/pinterest-icon'
import { usePathname } from 'next/navigation'
import { FE_URL } from '@/constants'

type Props = {
  sharedUrl?: string
  whatsapp?: Partial<React.ComponentProps<typeof WhatsappShareButton>>
  pinterest?: Partial<React.ComponentProps<typeof PinterestShareButton>> & {
    media: string
  }
  email?: Partial<React.ComponentProps<typeof EmailShareButton>>
  toggleBtnId?: string
}

export const ShareButtonV3 = ({
  sharedUrl,
  email,
  whatsapp,
  pinterest,
  toggleBtnId,
}: Props) => {
  const [open, setOpen] = useState(false)
  const refContainer = useRef<HTMLDivElement | null>(null)
  const pathName = usePathname()
  const linkShare = sharedUrl || `${FE_URL}${pathName}`

  const handleCloseMenu = () => {
    open && setOpen(false)
  }

  const handleToggleMenu = () => {
    setOpen((state) => !state)
  }

  useOnClickOutside(
    refContainer as React.RefObject<HTMLElement>,
    handleCloseMenu
  )

  return (
    <div className={s.container} ref={refContainer}>
      <button
        onClick={handleToggleMenu}
        className={s.shareButton}
        id={toggleBtnId}
        aria-label="Share"
      >
        <ShareIcon
          iconColor={open ? '#f68a5b' : '#131313'}
          svgProps={{
            width: 30,
            height: 30,
          }}
        />
      </button>

      <div
        className={cx(
          { [s.socialMediaContainerActive]: open },
          s.socialMediaContainer
        )}
      >
        <VisibleOn mobile tablet>
          <WhatsappShareButton {...whatsapp} url={linkShare}>
            <div className={cx(s.iconContainer, s.firstItem)}>
              <WhatsAppIcon />
              &nbsp;WhatsApp
            </div>
          </WhatsappShareButton>
        </VisibleOn>

        <PinterestShareButton
          {...pinterest}
          media={pinterest?.media!}
          url={linkShare}
        >
          <div className={cx(s.iconContainer, s.secondItem)}>
            <PinterestIcon
              iconColor="#131313"
              svgProps={{
                width: 16,
                height: 16,
              }}
            />
            &nbsp;Pinterest
          </div>
        </PinterestShareButton>

        <EmailShareButton {...email} url={linkShare}>
          <div className={cx(s.iconContainer, s.lastItem)}>
            <EmailIcon />
            &nbsp;Email
          </div>
        </EmailShareButton>
      </div>
    </div>
  )
}
